module.exports = "<section class=\"gw-endorsement-section-tile\">\r\n    <gw-wizard-tile state=\"getState()\" icon=\"fa-umbrella\">\r\n        <p>{{\"endorsement.pa.directives.templates.pa-coverages.Coverages\"| translate}}</p>\r\n    </gw-wizard-tile>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/endorsement/pa/directives/templates/pa-coverages.html
// module id = 596
// module chunks = 0